// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3QFXC","range":"MonthRangeSwitch_range__g8GQs","disabled":"MonthRangeSwitch_disabled__3_aF_"};